
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import FaizTuruPicker from "@/components/pickers/FaizTuruPicker.vue";
import HesapSekliPicker from "@/components/pickers/HesapSekliPicker.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import FaizTuruForm from "@/components/forms/FaizTuruForm.vue";
import {HesapSekliAciklamaLabel} from "@/enum/HesapSekli";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";
import {AlacakBelgeTuru} from "@/enum/AlacakBelgeTuru";

@Component({
  components: {
    FaizTuruForm,
    FormDialog,
    FaizTuruPicker,
    HesapSekliPicker,
    Tutar
  },
})
export default class Faizler extends Mixins(ObjectInputMixin) {
  @Prop() title!: string;
  @Prop() expanded!: boolean;
  @Prop() alacakBelgeTuruId!:number
  @Prop() defaultFaiz!: number;
  @Prop() protestoIhtar!: boolean | string;
  @Prop({default:"/api/v1/faiz-turu/?takibe_ozel_mi=false"}) action!:string ;

  // ObjectInputMixin'den gelen özellikler
  declare localValue: any;
  declare input: (value?: any, isChangeData?: boolean) => void;

  /*action: string = "";*/
  panel: number = -1;
  elleFaiz: AlacakKalemiEntity = new AlacakKalemiEntity();
  hesapSekliAciklamaLabel = HesapSekliAciklamaLabel;
  AlacakKalemiAlani = AlacakKalemiAlani;

  get elleFaizTuruModel() {
    if (this.localValue?.elle_faiz_mi && this.localValue?.elle_faiz_oran_mi) {
      return this.localValue?.takip_sonrasi_faiz_turu;
    }
    return this.localValue?.takip_oncesi_faiz_turu;
  }

  set elleFaizTuruModel(val: any) {
    if (!this.localValue) return;
    if (this.localValue.elle_faiz_mi && this.localValue.elle_faiz_oran_mi) {
      this.localValue.takip_sonrasi_faiz_turu = val;
    } else {
      this.localValue.takip_oncesi_faiz_turu = val;
    }
  }

  get rules() {
    return [(v: any) => !!v || 'Lütfen bu alanı doldurun.'];
  }

  get isMerkezBankasi() {
    if ((this.localValue?.takip_oncesi_faiz_turu_id == 5) ||
        (this.localValue?.takip_oncesi_faiz_turu_id == 6) ||
        (this.localValue?.takip_oncesi_faiz_turu_id == 10) ||
        (this.localValue?.takip_oncesi_faiz_turu_id == 11) ||
        (this.localValue?.takip_oncesi_faiz_turu_id == 12) ||
        (this.localValue?.takip_oncesi_faiz_turu_id == 13) ||
        (this.localValue?.takip_sonrasi_faiz_turu_id == 5) ||
        (this.localValue?.takip_sonrasi_faiz_turu_id == 6) ||
        (this.localValue?.takip_sonrasi_faiz_turu_id == 10) ||
        (this.localValue?.takip_sonrasi_faiz_turu_id == 11) ||
        (this.localValue?.takip_sonrasi_faiz_turu_id == 12) ||
        (this.localValue?.takip_sonrasi_faiz_turu_id == 13)) {
      return true;
    } else
      return false
  }

  get isProtestoIhtar() {
    return this.protestoIhtar || this.protestoIhtar === '';
  }

  get takipStore() {
    // TakipDetayView veya TakipEkleView'a göre doğru store'u seç
    const route = this.$route.path;
    if (route.includes('/icrapro/takip/') && !route.includes('/takip-ekle/')) {
      return 'takipDetay';
    }
    return 'takipEkle';
  }

  get takipBilgileri() {
    const storeName = this.takipStore;
    const state = this.$store.state[storeName];

    if (storeName === 'takipDetay') {
      return state?.takip?.takip_bilgileri || null;
    } else {
      return state?.item?.takip_bilgileri || null;
    }
  }

  get defaultTakipOncesiFaizTuruId() {
    if (this.localValue?.id) {
      return this.localValue.takip_oncesi_faiz_turu_id;
    }

    const takipBilgileri = this.takipBilgileri;
    if (takipBilgileri && takipBilgileri.talepler && takipBilgileri.talepler[0]) {
      return takipBilgileri.talepler[0].takip_alt_tipi?.takip_sonrasi_faiz_turu_id || null;
    }

    return null;
  }

  get defaultTakipSonrasiFaizTuruId() {
    if (this.localValue?.id) {
      return this.localValue.takip_sonrasi_faiz_turu_id;
    }

    const takipBilgileri = this.takipBilgileri;
    if (takipBilgileri && takipBilgileri.talepler && takipBilgileri.talepler[0]) {
      return takipBilgileri.talepler[0].takip_alt_tipi?.takip_oncesi_faiz_turu_id || null;
    }

    return null;
  }

  get takipTarihi() {
    const takipBilgileri = this.takipBilgileri;
    return takipBilgileri?.takip_tarihi || null;
  }

  onValueChange() {
    if (this.value && typeof this.value === 'object') {
      this.localValue = this.value;
    }
    if (this.localValue?.oran_aylik_mi == null) {
      this.localValue.oran_aylik_mi = false;
    }

    if (this.localValue) {
      this.localValue.takip_sonrasi_faiz_isle = this.localValue.takip_sonrasi_faiz_isle ?? true;
      this.localValue.gecikme_tazminati_mi = this.localValue.gecikme_tazminati_mi ?? true;
      this.localValue.takip_oncesi_faiz_isle = this.localValue.takip_oncesi_faiz_isle ?? true;
    }

    this.setElleFaiz();
  }

  onElleFaizMiChange() {
    if (this.localValue) {
      if (this.localValue.elle_faiz_mi) {
        this.localValue.takip_oncesi_faiz_turu_id = null;
        if (this.localValue.elle_faiz_oran_mi) {
          if (this.localValue.takip_oncesi_faiz_turu) {
            this.localValue.takip_sonrasi_faiz_turu = {...this.localValue.takip_oncesi_faiz_turu};
          }
          this.localValue.takip_oncesi_faiz_turu = {
            ...(this.localValue.takip_oncesi_faiz_turu || new FaizTuruEntity()),
            isim: 'Takip Öncesi Elle Faiz'
          };
        } else {
          this.localValue.takip_oncesi_faiz_turu = null;
        }
      }
      this.input();
    }
  }

  onElleFaizOranMiChange() {
    if (this.localValue) {
      this.localValue.takip_oncesi_faiz_turu = new FaizTuruEntity();
      if (this.localValue.elle_faiz_mi && this.localValue.elle_faiz_oran_mi) {
        this.localValue.takip_oncesi_faiz_turu.isim = 'Takip Öncesi Elle Faiz';
        this.localValue.takip_sonrasi_faiz_turu = new FaizTuruEntity();
      }
      this.localValue.takip_oncesi_faiz_turu_id = null;
      this.localValue.takip_sonrasi_faiz_turu_id = null;
      this.input();
    }
  }

  elleFaizInput(value?: any) {
    if (this.localValue) {
      if (this.localValue.elle_faiz_mi && typeof value === 'number') {
        this.localValue.elle_faiz_tutari = value;
      }

      if (this.localValue.elle_faiz_mi && this.localValue.elle_faiz_oran_mi) {
        if (this.localValue.takip_sonrasi_faiz_turu) {
          this.localValue.takip_oncesi_faiz_turu = {
            ...this.localValue.takip_sonrasi_faiz_turu,
            isim: 'Takip Öncesi Elle Faiz'
          };
        }
      } else if (this.localValue.takip_oncesi_faiz_turu) {
        this.localValue.takip_sonrasi_faiz_turu = {...this.localValue.takip_oncesi_faiz_turu};
      }

      this.input();
    }
  }
  setDefaultFaizValues() {
    if (this.localValue && !this.localValue.id) {
      const takipBilgileri = this.takipBilgileri;
      if (takipBilgileri && takipBilgileri.talepler && takipBilgileri.talepler[0]) {
        const takipAltTipi = takipBilgileri.talepler[0].takip_alt_tipi || {};

        // Takip sonrası faiz türü ID'sini set et (eğer yoksa)
        if (!this.localValue.takip_sonrasi_faiz_turu_id && takipAltTipi.takip_sonrasi_faiz_turu_id) {
          this.localValue.takip_oncesi_faiz_turu_id = takipAltTipi.takip_oncesi_faiz_turu_id;
          this.localValue.takip_sonrasi_faiz_turu_id = takipAltTipi.takip_sonrasi_faiz_turu_id;
        }

        // Hesap şeklini set et (eğer yoksa)
        if (!this.localValue.faiz_hesap_sekli && takipAltTipi.faiz_hesap_sekli) {
          this.localValue.faiz_hesap_sekli = takipAltTipi.faiz_hesap_sekli;
        }
      }
    }
  }

  @Watch('localValue')
  onLocalValueChange() {
    this.setDefaultFaizValues();
  }

  /** Parent objesini doğrudan kullan - ObjectInputMixin kopyası yerine referans.
   *  Takip öncesi/sonrası değişince açıklama gibi diğer alanların kaybolmasını önler. */
  @Watch('value')
  onValueSync() {
    if (this.value && typeof this.value === 'object') {
      this.localValue = this.value;
    }
  }

  mounted() {
    if (this.value && typeof this.value === 'object') {
      this.localValue = this.value;
    }
    if (this.expanded) this.panel = 0;
    this.setElleFaiz();
    this.setDefaultFaizValues();
  }

  setElleFaiz() {
    let elleFaiz = this.localValue?.children?.filter((child: AlacakKalemiEntity) => child.alacak_kalemi_alani_id == AlacakKalemiAlani.takipOncesiFaiz && !child.is_calculated)[0];
    if (elleFaiz) {
      this.elleFaiz = elleFaiz;
    }
  }
}
